import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUseProjectModelRequestFailure(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.projectModel.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isUseProjectModelRequestPending(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.projectModel.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isUseProjectModelRequestSuccess(projectModel, zone) {
      const req = getState().find(
        (req) =>
          req.projectModel.uuid === projectModel.uuid &&
          req.zone.uuid === zone.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
